export default __webpack_public_path__ + "static/media/loot.a99f1a36.wav";